export default __webpack_public_path__ + "static/media/gif.b0d245b1.gif";